/* eslint-disable camelcase */
import React, { useState } from 'react';
import styled from 'styled-components';
import { getEnv } from '@config';
import { moneyFormat } from '@helpers';
import { formatDate } from '@helpers/date'; 
import { Modal } from 'fpay-ui';
import { useTranslation } from 'react-i18next';
import { ModalToFsc } from '@components';
import { useAuth } from '@hooks';
import CardHeader from './CardHeader';
import Divider from '../../Divider';

const Title = styled.div`
  color: var(--gray-gray-400, #505050);
  font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px;
  margin-bottom: 24px;
`;

const Layout = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 0px 24px;
`;

const LayoutBoxes = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-top: 24px;
  margin-bottom: 24px;
`;

const LinkText = styled.div`
  color: var(--blue-blue, #0071ce);
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  padding-left: 4px;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

const LinkImage = styled.img``;

const LayoutLink = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  margin-bottom: 24px;
`;

const HeaderTransactionsDetailModal = ({
  data: { authorization_id, event_date, gross_value, details_transaction },
}) => {
  const { publicPath, country } = getEnv();
  const [showModalToFSC, setShowModalToFSC] = useState(false);
  const toggleShowModalToFSC = () => {
    setShowModalToFSC(!showModalToFSC);
  };
  const { t } = useTranslation();
  const { isSeller } = useAuth();
  return (
    <>
      <Layout>
        <Title>{t('transactions.modalDetail.title')}</Title>
        <Divider />
        <LayoutBoxes>
          <CardHeader
            title={t('transactions.modalDetail.payRef')}
            detail={details_transaction?.reference_number || '-'}
          />
          <CardHeader title={t('transactions.modalDetail.codeTitle')} detail={authorization_id} />
          <CardHeader title={t('transactions.modalDetail.date')} detail= {formatDate(event_date, 'DD-MM-YYYY | HH:mm', false, 'UTC', country) || '-'} />
          <CardHeader
            title={t('transactions.modalDetail.totalMount')}
            detail={moneyFormat(gross_value, true)}
          />
        </LayoutBoxes>
        <LayoutLink>
          <LinkImage src={`${publicPath}/linkImage.svg`} alt="link" />
          <LinkText onClick={() => setShowModalToFSC(true)} id="transactions-see-detail-fsc">
            {t('transactions.modalDetail.goToFSC')}
          </LinkText>
        </LayoutLink>
        <Divider />
      </Layout>
      {showModalToFSC && (
        <Modal fClose={toggleShowModalToFSC} showCloseButton={false} width="344px">
          <ModalToFsc
            text={t('homeScreen.cards.text')}
            handleConfirm={
              !isSeller()
                ? () => window.open(t('homeScreen.modalToFsc.linkToRegister'), '_blank', 'noopener')
                : () => window.open(t('homeScreen.modalToFsc.linkToFSC'), '_blank', 'noopener')
            }
            handleCancel={() => setShowModalToFSC(false)}
            textConfirm={t('homeScreen.modalToFsc.textConfirm')}
            textCancel={t('homeScreen.modalToFsc.textCancel')}
          />
        </Modal>
      )}
    </>
  );
};

export default HeaderTransactionsDetailModal;
